// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundles/lab/" + ({"165":"robot-light","181":"robot-blockly","299":"marker-v-barchart","397":"robot-code","457":"coding-problem-info-pastes","526":"problem","712":"coding-problem-blockly"}[chunkId] || chunkId) + "-chunk.js";
};